import React, { Component } from 'react';
import BaseLayout from '../../templates/base';
import SurveysEditForm from './../../elements/surveys/form';
import Loading from "../../elements/loading";
import SurveysAdd from './../../elements/surveys/widget/surveys_add';

class SurveyEdit extends Component {
	render(){
		const { surveys, status } = this.props;
		return(
			surveys.isFetching || surveys.types.isFetching || status.isFetching ? <Loading/>:<SurveysEditForm {...this.props}/>
		);
	}

	componentWillMount(){
		this.props.surveysFetchTypes();
		this.props.fetchStatus(1);
		this.props.fetchSurvey(this.props.match.params.id);
	}
}

//export default BaseLayout(SurveyEdit, {title: `Editar Encuesta`, subnav: {icon: 'fa-clipboard', name: 'Encuestas', actions: {url: '/encuestas/crear', name: 'Agregar encuesta'}}});
export default BaseLayout(SurveyEdit, {
	title: `Editar Encuesta`,
	subnav: {
		icon: 'fa-clipboard',
		name: 'Administracion',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <SurveysAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/surveys/edit.jsx